const User = ({ width }) => {
    return (
        <div className={`user-icon ${width} text-[#231F20]`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"

                fill="none"
                viewBox="0 0 109 110"
            >
                <path
                    fill="currentColor"
                    d="M54.708 109.097C24.81 109.097.484 84.785.484 54.903.484 25.02 24.81.708 54.708.708c29.9 0 54.224 24.312 54.224 54.195 0 29.882-24.325 54.194-54.224 54.194zm0-101.298C28.721 7.8 7.58 28.93 7.58 54.903c0 25.973 21.142 47.103 47.13 47.103 25.986 0 47.128-21.13 47.128-47.103 0-25.974-21.142-47.104-47.129-47.104z"
                ></path>
                <path
                    fill="currentColor"
                    d="M86.842 96.782h-7.094c0-13.799-11.234-25.025-25.04-25.025s-25.04 11.226-25.04 25.025h-7.094c0-17.708 14.416-32.115 32.134-32.115 17.719 0 32.134 14.407 32.134 32.115zM54.708 51.72c-7.87 0-14.273-6.398-14.273-14.264s6.403-14.265 14.273-14.265 14.273 6.4 14.273 14.265c0 7.866-6.403 14.265-14.273 14.265zm0-21.438c-3.958 0-7.178 3.219-7.178 7.174 0 3.956 3.22 7.174 7.178 7.174 3.958 0 7.178-3.218 7.178-7.174 0-3.956-3.22-7.174-7.178-7.174z"
                ></path>
            </svg>
        </div>
    )
}

export default User
